import { ChangeEvent, Dispatch, SetStateAction, useCallback, useState } from 'react'

export const useString = <T extends string>(
  initialState: T,
  unions: T[] = []
): {
  state: T
  handleState: (event: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>) => void
  setState: Dispatch<SetStateAction<T>>
  error: string
  setError: Dispatch<SetStateAction<string>>
} => {
  type Unions = (typeof unions)[number]
  const [state, setState] = useState<T>(initialState)
  const [error, setError] = useState<string>('')
  const isMatchedUnion = (value: string): value is Unions => {
    // unionsが指定されていなければただのstring型
    if (unions.length === 0) {
      return true
    } else {
      return unions.some((v) => v === value)
    }
  }
  const handleState = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const value = event.target.value
      if (!isMatchedUnion(value)) return
      setState(value)
    },
    [setState, unions]
  )
  return { state, handleState, setState, error, setError }
}

export default useString
